import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    value: '',
  },
  reducers: {
    setUser: (state,action) => {
      state.value = action.payload
    },
    clearUser:(state,action)=>{
        state.value = ''
    }
  },
})

export const { setUser} = userSlice.actions

export default userSlice.reducer